import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyrightOutlined } from '@ant-design/icons';
import { Layout } from 'antd';
import { Fragment } from 'react';
import { GlobalFooter } from './GlobalFooter';
var Footer = Layout.Footer;

var DefaultFooter = function DefaultFooter(_ref) {
  var links = _ref.links,
      copyright = _ref.copyright,
      style = _ref.style,
      className = _ref.className,
      prefixCls = _ref.prefixCls;
  return _jsx(Footer, {
    className: className,
    style: _objectSpread({
      padding: 0
    }, style),
    children: _jsx(GlobalFooter, {
      links: links,
      prefixCls: prefixCls,
      copyright: copyright === false ? null : _jsxs(Fragment, {
        children: [_jsx(CopyrightOutlined, {}), " ", copyright]
      })
    })
  });
};

export { DefaultFooter };